<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon">close</mat-icon>
</button>
<h3  mat-dialog-title align="center">Información Activo</h3>
<mat-progress-bar *ngIf="loading" mode="query" class="progressBar"></mat-progress-bar>
<mat-dialog-content  class="update-active">

    <table mat-table #table [dataSource]="dataSource">  
        <!-- Name Column -->
        <ng-container matColumnDef="nombre">
          <td type="text" mat-cell *matCellDef="let element"> <b>{{element.nombre}} </b></td>
        </ng-container>
    
        <!-- Field_Filter Column -->
        <ng-container matColumnDef="valor">
          <td type="text" mat-cell *matCellDef="let element"> {{element.valor}} </td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </mat-dialog-content>
<!-- <mat-dialog-actions>
    <button  mat-raised-button (click)='updateActive()'>Actualizar</button>
    <button  mat-raised-button (click)="deleteActive()">Eliminar</button>
</mat-dialog-actions> -->
